import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [role, setRole] = useState(() => localStorage.getItem("role"));
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  const [teacherEmail, setTeacherEmail] = useState(() => localStorage.getItem("teacherEmail"));
  const [school_id, setSchoolId] = useState(() => localStorage.getItem("schoolId"));
  const [authorInfo, setAuthorInfo] = useState(() => {
    const stored = localStorage.getItem("authorInfo");
    return stored ? JSON.parse(stored) : null;
  });

  const login = (role, token, teacherEmail, schoolId = null, authorInfo = null) => {
    setRole(role);
    setToken(token);
    setTeacherEmail(teacherEmail);
    setSchoolId(schoolId);
    setAuthorInfo(authorInfo);
    localStorage.setItem("role", role);
    localStorage.setItem("token", token);
    localStorage.setItem("teacherEmail", teacherEmail);
    if (schoolId) localStorage.setItem("schoolId", schoolId);
    if (authorInfo) localStorage.setItem("authorInfo", JSON.stringify(authorInfo));
  };

  const logout = () => {
    setRole(null);
    setToken(null);
    setTeacherEmail(null);
    setSchoolId(null);
    setAuthorInfo(null);
    localStorage.removeItem("role");
    localStorage.removeItem("token");
    localStorage.removeItem("teacherEmail");
    localStorage.removeItem("schoolId");
    localStorage.removeItem("authorInfo");
  };

  return (

    
    <AuthContext.Provider value={{ role, token, teacherEmail, school_id, authorInfo, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export default AuthContext;
